// react router
import { NavLink } from "react-router-dom";

const NavMenuItem = ({ destination, content }) => {
  return (
    <li className="text-white font-bold text-2xl">
      <NavLink to={destination}>{content}</NavLink>
    </li>
  );
};
export default NavMenuItem;
